(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.company-exit.controller
  (:require
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-controller]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.report.company.financials-chart.controller :as financials-ctl]
   [common.util :as cu]))

(defn- recent-exits-figures
  [current-portfolio]
  (concat [["Gross multiple" (:gross-multiple current-portfolio)]
           ["Gross IRR" (util/->percent-1-decimal (:gross-irr current-portfolio))]]
          (when-not (cu/blank-value? (str (:annual-yield-infra-only current-portfolio)))
            [["Annual yield (INFRA only)" (:annual-yield-infra-only current-portfolio)]])
          [["Total proceeds for CapMan funds" (:total-proceeds-for-capman-funds current-portfolio)]
           ["Remaining fair value" (:remaining-fair-value current-portfolio)]
           ["Holding period" (:holding-period current-portfolio)]
           ["EV at entry" (:ev-at-entry current-portfolio)]
           ["Entry multiple" (:entry-multiple current-portfolio)]
           ["EV at exit" (:ev-at-exit current-portfolio)]
           ["Exit multiple" (:exit-multiple current-portfolio)]
           ["Exit type" (:exit-type current-portfolio)]
           ["Industry" (:industry current-portfolio)]
           ["Number of employees at exit" (:number-of-employees-at-exit current-portfolio)]
           ["Case team" (:case-team current-portfolio)]]))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name         (get-in report-data [:holding-name])
   :reference-date       (get-in report-data [:reference-date])
   :report-id            (:report-id props)
   :case-overview-text   (report-ctl/rich-content
                          props
                          :case-overview-text)
   :recent-exits-figures (report-ctl/with-footnote
                          props
                          :recent-exits-figures-footnotes
                          (recent-exits-figures (get-in report-data [:basic-equity])))
   :financials           (->>
                           (get-in report-data [:financials])
                           (report-ctl/with-footnote props :financials-footnotes)
                           (report-ctl/with-editable-charts
                            props
                            :financials
                            financials-controller/company-financials
                            financials-controller/config->editable-data
                            financials-controller/editable-data->raw-data))})

